
import { defineComponent, PropType } from "vue";
import { Image } from "@/models/image";
import { Helper } from "@/utils/helper";

export default defineComponent({
    name: "NetworkImageComponent",
    props: {
        image: Object as PropType<Image>,
        width: Number,
        height: Number,
        placeholder: String,
        alt: String,
    },
    computed: {
        src() {
            if (this.image && this.width && this.height) {
                return Helper.getImageUrl(this.image, this.width, this.height);
            }

            return this.placeholder;
        },
    },
});
